import React from 'react';

export function Badge({ children, variant = 'primary', className = '' }) {
    const variants = {
        primary: 'bg-blue-600 text-white',
        secondary: 'bg-gray-600 text-white',
        success: 'bg-green-600 text-white',
        danger: 'bg-red-600 text-white',
        warning: 'bg-yellow-500 text-gray-900',
    };

    return (
        <span
            className={`px-3 py-1 rounded-full text-sm font-medium ${variants[variant]} ${className}`}
        >
            {children}
        </span>
    );
}
